function initialiseProductForms(root = document) {
  for (const form of root.querySelectorAll('.product-form')) {
    if (form.dataset.initialised) continue;
    form.dataset.initialised = 'true';
    const variantSelect = form.querySelector('[data-variant-select]');
    const planSelect = form.querySelector('[data-plan-select]');
    const price = form.querySelector('[data-product-price]');
    const priceData = form.querySelector('[data-plan-prices]');
    if (!variantSelect || !price || !priceData) continue;
    let variants;
    try { variants = JSON.parse(priceData.textContent).variants; } catch { continue; }
    const update = () => {
      const variant = variants.find((entry) => String(entry.id) === variantSelect.value);
      if (!variant) return;
      if (planSelect) {
        for (const option of planSelect.options) {
          option.disabled = option.value !== '' && !variant.plans.some((plan) => String(plan.id) === option.value);
        }
        if (planSelect.selectedOptions[0]?.disabled) {
          const available = Array.from(planSelect.options).find((option) => !option.disabled);
          if (available) planSelect.value = available.value;
        }
      }
      const plan = variant.plans.find((entry) => String(entry.id) === planSelect?.value);
      price.textContent = plan?.price ?? variant.price;
      const button = form.querySelector('button[name="add"]');
      if (button && planSelect && planSelect.options.length && !Array.from(planSelect.options).some((option) => !option.disabled)) {
        button.disabled = true;
        button.textContent = 'No purchase option available';
      } else if (button) {
        button.disabled = variantSelect.selectedOptions[0]?.disabled ?? true;
        button.textContent = button.disabled ? 'Currently unavailable' : `${button.dataset.purchaseLabel || 'Add to basket'} →`;
      }
    };
    variantSelect.addEventListener('change', update);
    planSelect?.addEventListener('change', update);
    update();
  }
}
initialiseProductForms();
document.addEventListener('shopify:section:load', (event) => initialiseProductForms(event.target));
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary')?.focus(); });
});
